module.exports = __webpack_public_path__ + "media/images/front/icon_drvideo-23de9af773178b9a0121b70de52f9aca.png";